import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";


function App() {
  const getRuntimeBase = () => {
    // prefer explicit build-time base when it's a path (not "./" or "/")
    if (__BASE_PATH__ && __BASE_PATH__ !== "./" && __BASE_PATH__ !== "/") return __BASE_PATH__;
    if (typeof window !== "undefined") {
      const first = window.location.pathname.split("/").filter(Boolean)[0] || "";
      return first ? `/${first}` : "";
    }
    return "";
  };
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={getRuntimeBase()}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
